import { Fragment, useState } from 'react';
import { Eye, X } from 'lucide-react';
import Modal from '../common/Modal';
import JsonTable from '../JsonTable';

const JsonTableModal = ({
  title = 'Data Table',
  data,
  triggerLabel = 'View Table',
  darkMode = true,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex text-sm items-center border border-gray-400/50 gap-2 text-white bg-black/30 hover:bg-gray-400/50 px-3 py-1 rounded-full transition duration-300 cursor-pointer"
      >
        <Eye size={16} />
        {triggerLabel}
      </button>

      {open && (
        <Modal open={open} setOpen={() => setOpen(false)} modalWidth="60%" isDark={darkMode}>
          <Fragment>
            <div className="flex justify-between items-center mb-2 p-2">
              <h2 className="text-lg font-semibold text-white">{title}</h2>
              <button
                className="bg-black text-red-500 size-7 rounded hover:bg-red-100 flex justify-center items-center"
                onClick={() => setOpen(false)}
              >
                <X size={16} />
              </button>
            </div>
            <div className="p-2 bg-gray-500/20 max-h-[400px] overflow-auto">
              <JsonTable data={data} darkMode={darkMode} />
            </div>
          </Fragment>
        </Modal>
      )}
    </>
  );
};

export default JsonTableModal;
